import _ from 'lodash';
_.noConflict();

function wrapArray (x) {
  if (_.isArray(x)) {
    return x;
  }
  return [x];
}

export default wrapArray;
